import { NLink } from '@innersource-nn/novoui-react';

export default function NoDatasetStatus() {
    return (
        <div className="empty-place-holder items-center text-true-blue">
            <div className="flex flex-col items-center">
                <div className="round-div-icon-middle bg-light-blue-200 h-[88px] w-[88px] ">
                    <div className="border-2 rounded-lg border-true-blue text-2xl h-40 w-40 flex flex-col items-center justify-center b">
                        ?
                    </div>
                </div>
                <p className="w-1/2 text-center mt-8">
                    Looks like you currently don't have any datasets to display!
                    Get started by{' '}
                    <NLink href="/" className="underline">
                        requesting access{' '}
                    </NLink>
                    to some datasets or upload your own datasets!
                </p>
            </div>
        </div>
    );
}
